<div class="widget__wrap">
    <div class="widget" id="news-widget">
        <h2 class="widget__header">
            <span class="widget__header__title">
                <i class="widget__header__icon ico-angle-down"></i> Novinky na webu</span>
            <span class="widget__header__tools">
                <a class="cta cta--small cta--green" [routerLink]="['news/add']">
                    <span class="cta__light">Přidat</span> novinku
                    <i class="ico-plus"></i>
                </a>
            </span>
        </h2>
        <div class="widget__content">
            <h3 class="widget__heading">Publikované novinky</h3>
            <swb-news-list></swb-news-list>
        </div>
    </div>
</div>